<template>
  <div class="meeting-agenda__items-container">
    <MeetingAgenda v-for="(agenda, index) in agendas" :key="index" :agenda="agenda"></MeetingAgenda>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import MeetingAgenda from './agendas/MeetingAgenda.vue';

  export default {
    name: 'MeetingAgendasContainer',
    components: {
      MeetingAgenda,
    },
    computed: {
      ...mapGetters('meetingAgendas', ['loaders', 'agendas', 'upcomingAgendas']),
    },
    mounted() {
      this.$store.dispatch('meetingAgendas/getAgendas');
    },
  };
</script>
